export const normalizeReportData = (data: any): any[] => {
  if (!Array.isArray(data)) return [];

  // Se vier de Promise.all com arrays por ano -> flatten de 1 nível
  if (data.length > 0 && Array.isArray(data[0])) {
    return data.reduce((acc: any[], curr: any) => acc.concat(curr), []);
  }

  return data;
}
